"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apollo_link_1 = require("apollo-link");
var traverse_1 = __importDefault(require("traverse"));
var graphql_1 = require("graphql");
var unionSelectionsCache = {};
var filterUnionLink = new apollo_link_1.ApolloLink(function (operation, forward) {
    var cachedSelections = unionSelectionsCache[operation.operationName];
    var result$ = forward(operation);
    if (cachedSelections) {
        // Skip operations without union types
        if (cachedSelections.length === 0)
            return result$;
        return result$.map(function (data) {
            return filterEmptyUnionSelections(data, cachedSelections);
        });
    }
    var unionTypeNames = getUnionTypeNamesFromDoc(operation.query);
    var unionSelectionNames = [];
    if (unionTypeNames.length > 0) {
        unionSelectionNames = getUnionSelections(operation.query, unionTypeNames);
        return result$.map(function (data) {
            return filterEmptyUnionSelections(data, unionSelectionNames);
        });
    }
    unionSelectionsCache[operation.operationName] = unionSelectionNames;
    return result$;
});
function getUnionTypeNamesFromDoc(doc) {
    return doc.definitions
        .filter(function (def) {
        return (def.kind === 'FragmentDefinition' && isEveryFragmentSpread(def));
    })
        .map(function (f) { return f.name.value; });
}
function isEveryFragmentSpread(node) {
    return node.selectionSet.selections.every(function (sel) { return sel.kind === 'FragmentSpread'; });
}
function getUnionSelections(ast, unionTypes) {
    var selectionNames = [];
    var unionTypeNames = unionTypes.slice();
    graphql_1.visit(ast, {
        Field: function (node) {
            // Bail out if all selections found for given union types
            if (unionTypeNames.length === 0)
                return graphql_1.BREAK;
            var alias = node.alias, name = node.name, selectionSet = node.selectionSet;
            unionTypeNames = unionTypeNames.filter(function (typeName) {
                var unionSelection = selectionSet &&
                    selectionSet.selections.find(
                    // InlineFragment does not have name property
                    function (v) { return !isInlineFragment(v) && v.name.value === typeName; });
                if (unionSelection) {
                    var selectionName = (alias || name).value;
                    selectionNames.push(selectionName);
                }
                return !unionSelection;
            });
        },
    });
    return selectionNames;
}
function filterEmptyUnionSelections(data, selectionNames) {
    var unionSelectionNames = selectionNames.slice();
    // NOTE: traverse-js API rely on execution context ("this")
    // eslint-disable-next-line array-callback-return
    return traverse_1.default(data).map(function filterUnion() {
        var _this = this;
        // Bail out if all selections filtered
        if (unionSelectionNames.length === 0)
            this.stop();
        unionSelectionNames = unionSelectionNames.filter(function (name) {
            var isUnionNode = name === _this.key;
            if (isUnionNode && Array.isArray(_this.node)) {
                _this.update(_this.node.filter(function (n) { return isEmptyNode(n); }));
            }
            return !isUnionNode;
        });
    });
}
function isEmptyNode(node) {
    return (typeof node === 'object' &&
        node !== null &&
        Object.keys(node).filter(function (k) { return k !== '__typename'; }).length > 0);
}
function isInlineFragment(selection) {
    return selection.kind === 'InlineFragment';
}
exports.default = filterUnionLink;
//# sourceMappingURL=filter-union-link.js.map